import styled from 'styled-components'
import {Input, Row, Text, theme} from '../../ui'
import {Button} from '@material-ui/core'

export const ModalText = styled(Text)`
  color: ${theme.color.base};
  font-weight: 500;
  font-size: 15px;
`

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 6px 4px;
  white-space: nowrap;
  gap: 8px;
`

export const ToggleGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  width: 100%;
  margin: 4px 0 12px;
`

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex: 1 1 200px;
  min-width: 200px;
  background: ${theme.color.whiteBackground};
  border: 1px solid ${theme.color.lightGrayBackground};
  border-radius: 10px;
  padding: 11px 16px;

  & > *:first-child {
    min-width: 0;
    white-space: normal;
    line-height: 1.25;
  }

  .MuiSwitch-root {
    flex-shrink: 0;
  }
`

export const ConfirmButton = styled(Button)`
  &.MuiButtonBase-root {
    font-size: 15px;
    font-weight: 600;
    text-transform: none;
    min-width: 132px;
    height: 44px;
    border-radius: 10px;
    background: ${theme.color.confirmButton};
    box-shadow: 0 4px 12px ${theme.color.confirmButton}33;
    transition: ${theme.css.transition};

    &:hover {
      background: ${theme.color.darkBlue};
      box-shadow: 0 6px 16px ${theme.color.confirmButton}4d;
    }

    color: ${theme.color.white};

    &.Mui-disabled {
      opacity: 0.4;
      box-shadow: none;
    }
  }
`

export const DeleteButton = styled(Button)`
  &.MuiButtonBase-root {
    font-size: 15px;
    font-weight: 600;
    text-transform: none;
    min-width: 120px;
    height: 44px;
    border-radius: 10px;
    background: transparent;
    border: 1.5px solid ${theme.color.red}66;
    transition: ${theme.css.transition};

    &:hover {
      background: ${theme.color.red}12;
      border-color: ${theme.color.red};
    }

    color: ${theme.color.red};

    &.Mui-disabled {
      opacity: 0.4;
    }
  }
`

export const ModalRow = styled(Row)`
  flex-wrap: wrap;
  width: 100%;
`

export const DialogHeaderText = styled.p`
  font-size: 20px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.3;
  letter-spacing: normal;
  text-align: right;
  color: ${theme.color.mekomiBlack};
  margin: 0;
`

export const InputContainer = styled.div`
  position: relative;
`

export const OutlinedInput = styled(Input)`
  border-radius: 8px;

  .MuiOutlinedInput-notchedOutline {
    border: solid 1.5px ${theme.color.inputGrayBorder};
    border-radius: 8px;
  }

  background-color: ${theme.color.white};
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`

export const InputErrorText = styled.span`
  position: absolute;
  right: 16px;
  bottom: -16px;
  color: ${theme.color.dangerRed};
  font-size: 12px;

  body[dir='ltr'] & {
    right: unset;
    left: 16px;
  }
`

export const InputWrapper = styled(InfoWrapper)`
  width: 100%;
  flex-direction: row;
  align-items: flex-start;
  gap: 14px;
`
